import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { HouseOrderGuestService } from "./house-order-guest.service";
import _ from "lodash";
import { TranslateService } from "@root/shared/service/translate.service";
import { takeUntil, tap } from "rxjs/operators";
import { Subject } from "rxjs";
import { CREDENTIAL_TYPE } from "@root/config";
import { NzModalService } from "ng-zorro-antd/modal";
import { NzContextMenuService, NzDropdownMenuComponent } from "ng-zorro-antd/dropdown";
import { listOfHeaderForGuestList } from "@root/router/guest-list/guest-list.props";
import { ViewVoucherComponent } from "@root/component/view-voucher/view-voucher.component";
import {
  SwitchPageService,
  PAGES_NAME,
  PageName
} from "@root/router/component/order-detail-sidebar/switch-page.service";
import { MultiHouseCalendarService } from "@root/router/house/component/multi-house-calendar/multi-house-calendar.service";
import { ModalService } from "@root/router/index/modal.service";

@Component({
  selector: "host-house-order-guest",
  templateUrl: "./house-order-guest.component.html",
  styleUrls: ["./house-order-guest.component.scss"],
})
export class HouseOrderGuestComponent implements OnInit, OnChanges, OnDestroy {
  @Input() code: string = null;
  /** @deprecated */
  @Input() from: "order" | "orderBox" | "calendar" | "" = "order";
  @Input() pageType: 'sidebar' | 'modal' = 'sidebar';
  @Output() refreshModal = new EventEmitter();

  guestList = [];
  checkedGuest = null;

  loading = false;
  listOfHeader = listOfHeaderForGuestList;
  countryList = [];

  private currentOrderPageRaw$ = this.switchPageService.currentNodeRaw$.pipe(
    tap((value) => {
      if (
        _.get(value, "refresh") &&
        _.get(value, "page") === PAGES_NAME.ORDER_DETAIL_GUEST
      ) {
        const params = {
          page: 1,
          page_size: 99999,
          reservation_code: this.code,
        };
        this.getGuestList(params);
      }
    })
  );

  private destroy$ = new Subject();

  constructor(
    private guestService: HouseOrderGuestService,
    private translateService: TranslateService,
    private contextMenuService: NzContextMenuService,
    private modalService: NzModalService,
    private switchPageService: SwitchPageService,
    private calendarService: MultiHouseCalendarService,
    private localModalService: ModalService
  ) {}

  ngOnInit() {
    if (this.pageType !== "sidebar") {
      this.getCountryList();
    }
    this.getData();
    this.currentOrderPageRaw$.pipe(takeUntil(this.destroy$)).subscribe();
    this.guestService.orderGuestListRefreshRaw$
      .pipe(takeUntil(this.destroy$))
      .subscribe((message) => {
        if (_.get(message, "refresh")) {
          this.code = _.get(message, "code");
          this.getData();
        }
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('changes: ', changes);
    if (changes["code"] && changes["code"].currentValue) {
      this.getData();
      // this.getPageAndDataForJump();
    }
  }

  getCountryList() {
    this.guestService.getCountryList().subscribe((res) => {
      if (res.error_code === 0) {
        this.countryList = _.get(res, "data");
      }
    });
  }

  getData() {
    const params = {
      page: 1,
      page_size: 99999,
      reservation_code: this.code,
    };
    if (this.pageType === "sidebar") {
      // 从小时单走房客的环，需要把小时单基本信息替换成房客基本信息
      if (_.get(this.switchPageService.biao, "rear.element.page") === 4) {
        this.switchPageService.changeRear({
          page: PAGES_NAME.HOUR_ORDER_DETAIL_BASIC,
          tab: 2,
          showBack: true,
          code: this.code,
        });
      } else if (this.switchPageService.biao.length === 0) {
        this.switchPageService.createNewLianBiao({
          page: PAGES_NAME.ORDER_DETAIL_GUEST,
          code: this.code,
          tab: 2,
        });
      }

      this.getGuestList(params);
    } else {
      this.getGuestTable(params);
    }
  }

  getGuestList(params) {
    this.loading = true;
    this.guestService.getGuestList(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.loading = false;
        this.guestService.updateOrderGuestListRefresh({
          refresh: false,
          code: null,
        });
        this.guestList = this.format(_.get(res, "data.list"));
      }
    });
  }

  format(data) {
    _.forEach(data, (guest) => {
      _.assign(guest, {
        idType: this.getIdType(_.get(guest, "id_type")),
      });
    });
    return data;
  }

  getGuestTable(params) {
    this.loading = true;
    this.guestService.getGuestList(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.loading = false;
        this.guestList = this.formatGuestTable(_.get(res, "data.list"));
      }
    });
  }

  formatGuestTable(data) {
    _.forEach(data, (guest) => {
      const tags = _.join(_.map(_.get(guest, "client_tags"), "name"), ",");
      _.assign(guest, {
        tags: tags,
      });
    });
    return data;
  }

  getIdType(value) {
    const item = _.find(CREDENTIAL_TYPE, { value });
    return item ? this.translateService.syncGet(item.i18nName) : null;
  }

  showItem(value) {
    return value === "" || value === null ? false : true;
  }

  checkGuestDetail(id) {

    this.switchPageService.navigate(
      PageName.GuestDetail,
      { id, code: this.code }
    );

    /** @deprecated */
    this.switchPageService.insertNodeAndUpdateCurrentNode({
      page: PAGES_NAME.GUEST_DETAIL,
      id: id,
      showBack: true,
      code: this.code,
    });
  }

  onContextMenu(event, menu: NzDropdownMenuComponent) {
    this.contextMenuService.create(event, menu);
  }

  deleteGuest(id) {
    this.modalService.warning({
      // nzTitle: "即将从入住单中移除此房客，但房客数据依然保留，确定移除吗？",
      nzTitle: this.translateService.syncGet("warning.remove_guest_info"),
      nzCancelText: this.translateService.syncGet("word.cancel"),
      nzOkText: this.translateService.syncGet("word.confirm"),
      nzOnOk: () => this.queryDelete(id),
    });
  }

  queryDelete(id) {
    this.guestService
      .deleteGuest({
        client_id: id,
        reservation_code: this.code,
      })
      .subscribe((res) => {
        if (res.error_code === 0) {
          this.getData();
          const refresh = true;
          this.refreshModal.emit(refresh);
          if (this.pageType === "sidebar") {
            this.calendarService.refresh();
          }
        }
      });
  }

  showCredentials(data) {
    if (data.length === 0) {
      return;
    }
    const list = [];
    _.forEach(data, (info) => {
      list.push({
        url: _.get(info, "urls.large_url"),
      });
    });
    this.modalService.create({
      nzTitle: this.translateService.syncGet("word.credentials"),
      nzWidth: 715,
      nzFooter: null,
      nzContent: ViewVoucherComponent,
      nzComponentParams: {
        pictureList: list,
      },
    });
  }

  closePannel() {
    this.calendarService.cancelSelectReservation();
    this.switchPageService.destroyCurrentLianBiao();
  }

  addGuest() {
    const duplicateGuestModal = this.localModalService.displayDuplicateGuestModal();
    duplicateGuestModal.afterClose.subscribe((res) => {
      if (res && res.type === "onClickCreateGuest") {
        const createGuestModal = this.localModalService.displayCreateGuestModal(
          res.data
        );
        // 添加一个新的房客
        createGuestModal.afterClose.subscribe((message) => {
          if (message && message.type === "onSuccess") {
            this.relateGuestToOrder(message.data.id);
          }
        });
      }
      if (res && res.type === "onClickExistGuest") {
        // 需要将data绑定到入住单上
        this.relateGuestToOrder(res.data.id);
      }
    });
  }

  relateGuestToOrder(id) {
    const params = {
      client_id: id,
      reservation_code: this.code,
    };
    this.guestService.addGuestToReservation(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.getData();
        const refresh = true;
        this.refreshModal.emit(refresh);
      }
    });
  }

  getCountryName(country) {
    let notFind = true;
    let item;
    for (let i = 0; i < this.countryList.length && notFind; i++) {
      item = _.find(_.get(this.countryList[i], "members"), { alpha2: country });
      if (item) {
        notFind = false;
      }
    }
    return item ? item.name : "-";
  }

  editGuest(guest) {
    _.assign(guest, {
      id_type: _.get(guest, "id_type") === "" ? null : _.get(guest, "id_type"),
    });
    const modal = this.localModalService.displayUpdateGuestModal(guest);
    modal.afterClose.subscribe((res) => {
      if (res && res.type === "onSuccess") {
        const refresh = true;
        this.refreshModal.emit(refresh);
        this.getData();
        if (this.pageType === "sidebar") {
          this.calendarService.refresh();
        }
      }
    });
  }

  checkSimilarGuest(id) {
    this.switchPageService.navigate(
      PageName.GuestSimilar,
      { id }
    );

    /** @deprecated */
    this.switchPageService.insertNodeAndUpdateCurrentNode({
      page: PAGES_NAME.GUEST_SIMILAR,
      id: id,
      showBack: true,
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
